import React from 'react';
import PropTypes from 'prop-types';
import SelectOption from './SelectOption';

export class Select extends React.Component {
  constructor(props) {
    super(props);
    this._handleOnChange = this._handleOnChange.bind(this);
    this._handleOnBlur = this._handleOnBlur.bind(this);
    this.focus = this.focus.bind(this);
  }

  focus() {
    this.select.focus();
  }

  _handleOnChange(e) {
    const { id, onChange } = this.props;
    onChange(id, e.target.value);
  }

  _handleOnBlur(e) {
    const { id, onBlur } = this.props;
    onBlur(id, e.target.value);
  }

  render() {
    const { value, options, id, className, disabled, tabIndex } = this.props;

    const optionComponents = options.map(o => <SelectOption key={o.value} text={o.text} value={o.value} disabled={o.disabled} />);

    return (
      <select
        id={id}
        disabled={disabled}
        value={value}
        className={`${className} pxl-form-control`}
        onBlur={this._handleOnBlur}
        onChange={this._handleOnChange}
        tabIndex={tabIndex}
        ref={select => {
          this.select = select;
        }}
      >
        {optionComponents}
      </select>
    );
  }
}

Select.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.array,
  tabIndex: PropTypes.number,
  value: PropTypes.any
};

Select.defaultProps = {
  className: '',
  disabled: false,
  onBlur() {},
  onChange() {},
  options: [],
  tabIndex: 0
};

export default Select